function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.12 8.13l-1.42.85-13.94 8.36A8.973 8.973 0 013 12a9 9 0 019-9c3.58 0 6.68 2.1 8.12 5.13z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 12a9 9 0 01-9 9c-2.47 0-4.7-.99-6.33-2.61l.09-.05L19.7 9.98l.93-.55c.24.82.37 1.68.37 2.57z"
})));